import { useEffect } from "react";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

export const useSliderControl = (sliders, setSliderId) => {
  const location = useLocation();

  useEffect(() => {
    // Greater control over slider when navigating between primaries
    // both in-app and out of app navigation.
    // ie. quotes => timesheets
    // But when navigating from calendar or navigating from one primary type to another specifc primary,
    // it will preserve the primary on the slider.
    // console.log("location.satte", location.state);
    if (location.state?.preservePrimary && sliders) {
      // In app navigation. Slider control explicitly stated
      // console.log("in c1");
      setSliderId(location.state?.data?.uid);
    } else if (location?.state == null && sliders) {
      // Cold load of page: useful when app is navigated to (eg: from submissions frontend)
      // Will default to whether or not sliders are on or off
      let urlSegments = location.pathname.split("/");
      if (urlSegments.length > 2) {
        let lastSegment = urlSegments[urlSegments.length - 1];
        setSliderId(lastSegment);
      }
    } else {
      // Close slider in all other cases
      setSliderId(null);
    }
  }, []);
};
